var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbt01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.954 25.78L33.984 42.832C34.0179 43.0328 33.9898 43.2392 33.9032 43.4235C33.8167 43.6079 33.676 43.7614 33.4999 43.8636C33.3237 43.9658 33.1206 44.0118 32.9176 43.9954C32.7146 43.9791 32.5215 43.9011 32.364 43.772L25.204 38.398C24.8583 38.1398 24.4384 38.0003 24.007 38.0003C23.5755 38.0003 23.1556 38.1398 22.81 38.398L15.638 43.77C15.4806 43.8989 15.2877 43.9767 15.085 43.9931C14.8822 44.0095 14.6793 43.9637 14.5033 43.8618C14.3273 43.7598 14.1865 43.6067 14.0998 43.4227C14.0131 43.2387 13.9846 43.0327 14.018 42.832L17.046 25.78",
    stroke: "#C9A962",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 28C30.6274 28 36 22.6274 36 16C36 9.37258 30.6274 4 24 4C17.3726 4 12 9.37258 12 16C12 22.6274 17.3726 28 24 28Z",
    stroke: "#C9A962",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbt01);
export default __webpack_public_path__ + "static/media/abt01.74f3f02815ce373959553f014f9ab3dc.svg";
export { ForwardRef as ReactComponent };